import type { CallbackEvent } from "@shopify/polaris-types";
import {
  CollapsibleSectionCard,
  SectionHeader,
  Divider,
  TemplateCodes,
  ColorRow,
} from "../../../components/shared/EditorShared";

// ─── Section 4: Textos del popup ──────────────────────────────────────────────

export function PopupTextsSection({
  titleTemplate,
  onTitleChange,
  subtitleTemplate,
  onSubtitleChange,
  productTitleOverride,
  onProductTitleChange,
  description,
  onDescriptionChange,
}: {
  titleTemplate: string;
  onTitleChange: (v: string) => void;
  subtitleTemplate: string;
  onSubtitleChange: (v: string) => void;
  productTitleOverride: string;
  onProductTitleChange: (v: string) => void;
  description: string;
  onDescriptionChange: (v: string) => void;
}) {
  return (
    <CollapsibleSectionCard
      header={<SectionHeader number={4} title="Textos del popup" />}
    >
      <s-stack direction="block" gap="base">
        <s-stack direction="block" gap="small-200">
          <s-text-field
            label="Título"
            value={titleTemplate}
            onInput={(e: CallbackEvent<"s-text-field">) =>
              onTitleChange(e.currentTarget.value)
            }
          />
          <TemplateCodes />
        </s-stack>

        <Divider />

        <s-stack direction="block" gap="small-200">
          <s-text-field
            label="Subtítulo"
            value={subtitleTemplate}
            onInput={(e: CallbackEvent<"s-text-field">) =>
              onSubtitleChange(e.currentTarget.value)
            }
          />
          <TemplateCodes />
        </s-stack>

        <Divider />

        <s-stack direction="block" gap="small-200">
          <s-text-field
            label="Título del producto"
            value={productTitleOverride}
            onInput={(e: CallbackEvent<"s-text-field">) =>
              onProductTitleChange(e.currentTarget.value)
            }
          />
          <s-text color="subdued">
            Si se deja vacío, se usará el título del producto de Shopify.
          </s-text>
        </s-stack>

        <Divider />

        <s-stack direction="block" gap="small-200">
          <s-text-area
            label="Descripción del producto"
            value={description}
            rows={3}
            onInput={(e: CallbackEvent<"s-text-area">) =>
              onDescriptionChange(e.currentTarget.value)
            }
          />
          <s-text color="subdued">
            Si se deja vacío, se usará la descripción del producto de Shopify.
          </s-text>
        </s-stack>
      </s-stack>
    </CollapsibleSectionCard>
  );
}

// ─── Section 5: Colores ───────────────────────────────────────────────────────

export function ColorsSection({
  titleColor,
  onTitleColorChange,
  priceColor,
  onPriceColorChange,
}: {
  titleColor: string;
  onTitleColorChange: (v: string) => void;
  priceColor: string;
  onPriceColorChange: (v: string) => void;
}) {
  return (
    <CollapsibleSectionCard
      header={<SectionHeader number={5} title="Colores" />}
    >
      <s-stack direction="block" gap="base">
        <ColorRow
          label="Color del título"
          value={titleColor}
          onChange={onTitleColorChange}
        />
        <Divider />
        <ColorRow
          label="Color del precio del producto"
          value={priceColor}
          onChange={onPriceColorChange}
        />
      </s-stack>
    </CollapsibleSectionCard>
  );
}
